// Display-only fence. Never authorizes a write or substitutes for server CAS.
// A poll started before an action (or a cached snapshot missing that action)
// cannot put the operator's own just-saved card back into its previous state.
export function createOwnActionSnapshots() {
  let sequence = 0;
  const roots = new Map();
  const keyFor = row => `${row?.storeId ?? row?.lojaAtual ?? ""}:${row?.id ?? ""}`;
  const equal = (a,b) => JSON.stringify(a) === JSON.stringify(b);
  return {
    startRead() { return ++sequence; },
    clear() { roots.clear(); sequence++; },
    remember(root, saved, previous = {}) {
      if (saved?.id == null) return;
      if (!roots.has(root)) roots.set(root,new Map());
      const changes = Object.fromEntries(Object.entries(saved).filter(([key,value]) =>
        !key.startsWith("__") && !equal(value,previous[key])));
      const entries = roots.get(root), key = keyFor(saved), prior = entries.get(key);
      entries.set(key,{ saved, changes:{...(prior?.changes || {}),...changes},
        owner:saved.consultantId, at:++sequence, acknowledgedAt:null });
    },
    reconcile(root, incoming, readSequence) {
      const entries = roots.get(root);
      if (!entries) return incoming;
      return (incoming || []).map(row => {
        const entry = entries.get(keyFor(row));
        if (!entry || String(entry.owner ?? "") !== String(row.consultantId ?? "")) return row;
        const matches = Object.entries(entry.changes).every(([key,value]) => equal(row[key],value)
          || (value == null && row[key] == null));
        if (readSequence > entry.at && matches) entry.acknowledgedAt = readSequence;
        if (entry.acknowledgedAt != null && readSequence > entry.acknowledgedAt) return row;
        return {...row,...entry.changes};
      });
    },
  };
}
